import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { makeApiCall } from "../utils/apiHelpers";
import { BASE_URL } from "../config";
import Swal from "sweetalert2";

const ProfilePage = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null); // Store user details
  const [loading, setLoading] = useState(true); // Loading state

  // Fetch user details
  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await makeApiCall(`${BASE_URL}/me`, "GET");
        setUser(response.data); // Access the `data` field from the response
      } catch (error) {
        Swal.fire("Error", "Failed to fetch user details", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchUserDetails();
  }, []);

  // Loading skeleton
  if (loading) {
    return (
      <div className="p-6 bg-gray-100 min-h-screen">
        <div className="bg-white p-6 rounded-lg shadow-md max-w-2xl mx-auto">
          <div className="animate-pulse space-y-4">
            <div className="h-8 bg-gray-200 rounded w-1/2 mb-6"></div>
            {[...Array(5)].map((_, index) => (
              <div key={index} className="flex justify-between">
                <div className="h-4 bg-gray-200 rounded w-1/4"></div>
                <div className="h-4 bg-gray-200 rounded w-1/3"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Display message if user is not found
  if (!user) {
    return (
      <div className="p-6 bg-gray-100 min-h-screen">
        <div className="bg-white p-6 rounded-lg shadow-md max-w-2xl mx-auto">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">User Profile</h1>
            <button
              onClick={() => navigate(-1)}
              className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition-colors"
            >
              <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
              Back
            </button>
          </div>
          <div className="text-center text-gray-500 py-10">
            <p className="text-lg">User not found.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="bg-white p-6 rounded-lg shadow-md max-w-2xl mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">User Profile</h1>
          <button
            onClick={() => navigate(-1)}
            className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition-colors"
          >
            <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
            Back
          </button>
        </div>

        {/* User Details */}
        <div className="space-y-4">
          <div className="flex justify-between">
            <p className="text-gray-600">Username:</p>
            <p className="text-gray-800 font-medium">{user.username}</p>
          </div>
          <div className="flex justify-between">
            <p className="text-gray-600">First Name:</p>
            <p className="text-gray-800 font-medium">{user.first_name}</p>
          </div>
          <div className="flex justify-between">
            <p className="text-gray-600">Last Name:</p>
            <p className="text-gray-800 font-medium">{user.last_name}</p>
          </div>
          <div className="flex justify-between">
            <p className="text-gray-600">Email:</p>
            <p className="text-gray-800 font-medium">{user.email || "N/A"}</p>
          </div>
          <div className="flex justify-between">
            <p className="text-gray-600">Email Verified:</p>
            <p className="text-gray-800 font-medium">
              {user.email_verified ? "Yes" : "No"}
            </p>
          </div>
          <div className="flex justify-between">
            <p className="text-gray-600">Created At:</p>
            <p className="text-gray-800 font-medium">
              {new Date(user.created_at).toLocaleString()}
            </p>
          </div>
          <div className="flex justify-between">
            <p className="text-gray-600">Last Updated:</p>
            <p className="text-gray-800 font-medium">
              {new Date(user.updated_at).toLocaleString()}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
